import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Icon } from 'antd';

import { NoPrint } from '../../../../components/PrintElement';
import EmailQuoteButton from '../EmailQuoteButton';

import {
  formatMileage,
  getCustomerEmail,
  getPlanMonths,
  isQuoteEmailSent,
} from '../../utils';

import s from './styles.less';

const propTypes = {
  planId: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  sent: PropTypes.bool.isRequired,
  regNumber: PropTypes.string,
  currentMileage: PropTypes.number,
  carPhoto: PropTypes.string,
  carInfo: PropTypes.shape({
    carMaker: PropTypes.string,
    carModel: PropTypes.string,
    transmission: PropTypes.string,
    fuelType: PropTypes.string,
    engineSize: PropTypes.number,
  }),
  withPlanDetails: PropTypes.bool,
  packageName: PropTypes.string,
  planMonths: PropTypes.number,
  monthlyPayments: PropTypes.number,
  monthlyPaymentsCount: PropTypes.number,
};
const defaultProps = {
  regNumber: null,
  currentMileage: null,
  packageName: null,
  carPhoto: null,
  carInfo: {},
  planMonths: null,
  monthlyPayments: null,
  monthlyPaymentsCount: null,
  withPlanDetails: true,
};

const CarInfo = ({
  planId,
  email,
  sent,
  regNumber,
  currentMileage,
  packageName,
  carPhoto,
  carInfo,
  planMonths,
  monthlyPayments,
  monthlyPaymentsCount,
  withPlanDetails,
}) => (
  <div className={s.carInfo}>
    <div className={s.carInfo_img_box}>
      <img
        src={`http://www2.carwebuk.com/${carPhoto}`}
        className={s.carInfo_img}
        role="presentation"
      />
      <div className={s.small}>
        *if this is not the car you are expecting please call 0330 1235 368
      </div>
    </div>
    <div className={s.carInfo_text}>
      <b>Registration</b>
      <h4>{regNumber || 'No Registration given'}</h4>
      <b>Car</b>
      <div>
        <div className={s.carInfo_details}>
          <div className={s.table}>
            <div>
              <div>Make</div>
              <div>{carInfo.carMaker}</div>
            </div>
            <div>
              <div>Model</div>
              <div>{carInfo.carModel}</div>
            </div>
            <div>
              <div>Transmission</div>
              <div>{carInfo.transmission}</div>
            </div>
            <div>
              <div>Fuel Type</div>
              <div>{carInfo.fuelType}</div>
            </div>
            <div>
              <div>Engine Capacity</div>
              <div>{carInfo.engineSize}</div>
            </div>
          </div>
        </div>
      </div>
      <b>Current Mileage</b>
      <h4>{formatMileage(currentMileage)}</h4>
    </div>
    <div>
      {withPlanDetails && (
        <div className={s.carInfo_plan}>
          <div className={s.packageName}>{packageName}</div>
          <div>{planMonths} month plan</div>
          <NoPrint>
            <div>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                className={s.actionButton}
                onClick={window.print}
              >
                <span className={s.emailButtonIcon}>
                  <Icon type="printer" />
                </span>
                <span>Print Quote</span>
              </Button>
            </div>
            <div>
              <EmailQuoteButton
                className={s.actionButton}
                planId={planId}
                email={email}
                sent={sent}
              />
            </div>
          </NoPrint>
          <div>
            <div className={s.font_18}>
              &pound;
              {monthlyPayments.toFixed(2)} per month
            </div>
            <div className={s.font_18}>
              {monthlyPaymentsCount} monthly payments
              <span className={s.relative}>
                <div className={s.services_iteminfo}>i</div>
                <div className={s.services_tooltip}>
                  <div className={s.services_tooltip_arrow} />
                  <div className={s.services_tooltip_title}>
                    Number of Payments
                  </div>
                  <div className={s.services_tooltip_content}>
                    <div>
                      The number of payments is based on schedules estimated
                      future usage
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);

CarInfo.propTypes = propTypes;
CarInfo.defaultProps = defaultProps;

const mapStateToProps = ({ quote: { quoteDetails } }) => {
  const {
    id: planId,
    paymentMonths,
    paymentSumPerMonth,
    Package: { name: packageName },
    Components,
  } = quoteDetails;

  return {
    planId,
    packageName,
    sent: isQuoteEmailSent(quoteDetails),
    monthlyPaymentsCount: paymentMonths,
    monthlyPayments: paymentSumPerMonth,
    planMonths: getPlanMonths(Components),
    email: getCustomerEmail(quoteDetails),
  };
};

export default connect(mapStateToProps)(CarInfo);
